import { Dialog, DialogContent } from '@src/design-system/dialog';
import PlanDialog from './common/plan-dialog';
import Crown from '../assets/icons/shared/crown-yellow.png';
import type { FC } from 'react';
import { useEffect, useMemo, useState } from 'react';
import { calculateDaysBetween } from '@shared/utils/helpers/calculate-days-between';
import { FREE_TRIAL_DURATION } from '@shared/constants/common';
import useCheckSubscription from '../hooks/use-check-subscription';

const UpgradeMenu: FC = () => {
  const { subscription } = useCheckSubscription();
  const [isOpen, setIsOpen] = useState(false);
  const [freeTrialEnded, setFreeTrialEnded] = useState(false);
  const duration = useMemo(
    () =>
      calculateDaysBetween(new Date().toISOString(), subscription?.trial_end),
    [subscription?.trial_end]
  );

  useEffect(() => {
    if (subscription && subscription.status !== 'NONE') {
      if (duration && duration < 0) {
        setFreeTrialEnded(true);
      }
    }
  }, [subscription, duration]);

  return (
    <>
      {duration && duration > 0 ? (
        <div
          className='flex items-center gap-3 h-full border border-secondary-200 bg-secondary-50 rounded-2xl p-1 px-3 cursor-pointer'
          onClick={() => {
            if (duration <= 0) {
              setFreeTrialEnded(true);
              setIsOpen(true);
            }
          }}
        >
          <div className='w-12 h-12 p-1 rounded-xl bg-secondary-100'>
            <img
              src={Crown}
              alt='crown'
            />
          </div>
          <div className='flex flex-col items-start'>
            <p className='text-gray-800 font-medium text-sm'>
              {subscription?.plan.name}
            </p>
            <p className='text-secondary-1000 font-medium text-xs'>
              {`${duration} Days Left`}
            </p>
          </div>
        </div>
      ) : null}

      <Dialog
        open={isOpen}
        onOpenChange={setIsOpen}
        defaultOpen={duration === FREE_TRIAL_DURATION}
        modal={true}
      >
        <DialogContent align='center'>
          <PlanDialog freeTrialEnded={freeTrialEnded} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UpgradeMenu;
